import { render, staticRenderFns } from "./colForm.vue?vue&type=template&id=1630c075&scoped=true&"
import script from "./colForm.vue?vue&type=script&lang=js&"
export * from "./colForm.vue?vue&type=script&lang=js&"
import style0 from "./colForm.vue?vue&type=style&index=0&id=1630c075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630c075",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1630c075')) {
      api.createRecord('1630c075', component.options)
    } else {
      api.reload('1630c075', component.options)
    }
    module.hot.accept("./colForm.vue?vue&type=template&id=1630c075&scoped=true&", function () {
      api.rerender('1630c075', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/colForm.vue"
export default component.exports